import { render } from "./Home.vue?vue&type=template&id=12bf7b66&scoped=true&ts=true"
import script from "./Home.vue?vue&type=script&lang=ts"
export * from "./Home.vue?vue&type=script&lang=ts"

import "./Home.vue?vue&type=style&index=0&id=12bf7b66&lang=scss&scoped=true"
import "./Home.vue?vue&type=style&index=1&id=12bf7b66&lang=css"

import exportComponent from "E:\\project\\help-center\\help-center-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12bf7b66"]])

export default __exports__